import { createModuleContext } from '@rebuild/utils/moduleContext';

const MODULE_NAME = 'company_profile_hk00656';

function buildBaseCtx() {
	return {
		companyIntro: {
			title: '公司简介',
			summary:
				'创新驱动的全球家庭消费产业集团。复星创立于1992年，经过逾30年发展，已成为一家创新驱动的全球家庭消费产业集团。秉持让全球家庭生活更幸福的使命，复星致力于服务全球家庭客户战略聚焦健康、快乐、富足的幸福生态系统。2007年复星国际在香港联交所主板上市（股份代号：00656.HK)，截至2024年12月31日，公司总资产达人民币7,965亿元，MSCI ESG评级为AA。'
		},

		latestData: {
			title: '最新数据',
			subtitle: '(2025年中期报告/单位：元)',
			metrics: [
				{
					value: '872.8',
					unit: '亿元',
					label: '总收入'
				},
				{
					value: '31.5',
					unit: '亿元',
					label: '产业运营利润'
				},
				{
					value: '6.6',
					unit: '亿元',
					label: '归母净利润'
				},
				{
					value: '636.1',
					unit: '亿元',
					label: '四大核心子公司总收入',
					note: '占集团总收入的比重达73%'
				}
			]
		},

		governance: {
			title: '公司治理',
			content: `复星国际决心以高水平的企业管治保障股东的利益，提高企业价值及责任。复星国际建立了完善的企业管治架构，董事会负责领导及监控业务、战略决策和表现，下设审核委员会、薪酬委员会、提名委员会及环境、社会及管治委员会，以审查专项事宜。
            (参见(https://ir.fosun.com/cn/investor-relations/corporate-governance/))`
		},

		executives: {
			title: '董监高简介'
		},

		contactInfo: {
			title: '联系我们',
			address: '上海市黄浦区中山东二路600号外滩金融中心',
			website: 'www.fosun.com',
			email: 'IR@fosun.com'
		}
	};
}

const { provide: provideCurrentContext, use: useCurrentContext } = createModuleContext(MODULE_NAME, buildBaseCtx);

export { provideCurrentContext, useCurrentContext };
